import classNames from 'classnames'
import { Visibility } from 'globalTypes'

import { gql, useQuery } from '@apollo/client'
import { IconName, library } from '@fortawesome/fontawesome-svg-core'
import { faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

library.add(faLock, faLockOpen)

interface ItemVisibilityProps {
  id: string
  collectionId: string
  iconClassName?: string
  visibility?: Visibility
  wrapperClassName?: string
}

const GET_ELEMENT_VISIBILITY_FOR_COLLECTION = gql`
  query GetElementVisibilityForCollection($id: ID!, $collectionId: String!) {
    element(id: $id) {
      __typename

      ... on Content {
        id
        visibilityForCollection(collectionId: $collectionId)
      }
    }
  }
`

const ItemVisibilityForCollection = ({
  id,
  collectionId,
  iconClassName,
  visibility,
  wrapperClassName,
}: ItemVisibilityProps) => {
  const { data, loading } = useQuery(GET_ELEMENT_VISIBILITY_FOR_COLLECTION, {
    variables: {
      id: id,
      collectionId: collectionId,
    },
  })

  const curVisibility = loading
    ? visibility
    : data?.element.visibilityForCollection

  const icons = {
    [Visibility.public]: 'lock-open',
    [Visibility.protected]: 'lock',
  }
  const customWrapperClass = wrapperClassName
    ? wrapperClassName
    : 'justify-center w-8 h-8 rounded-full'

  const customIconClass = iconClassName
    ? iconClassName
    : 'text-gray-500 text-sm'

  return (
    <span className={classNames(['flex items-center', customWrapperClass])}>
      {curVisibility && (
        <FontAwesomeIcon
          icon={['fas', icons[curVisibility] as IconName]}
          className={customIconClass}
        />
      )}
    </span>
  )
}

export default ItemVisibilityForCollection
